const AUTH_ERRORS = {
  'auth/email-already-in-use':
    "Email già in uso, prova ad accedere o registrati con un'altra email",
  'auth/invalid-email': 'Email non valida',
  'auth/weak-password': 'Password troppo debole',
  'auth/wrong-password': 'Password errata',
  'auth/user-not-found': 'Utente non trovato',
  'auth/invalid-login-credentials': 'Email o password non valide',
  'auth/invalid-credential': 'Email o password non valide',
};

const getAuthError = (error) => {
  return AUTH_ERRORS[error] || 'Errore sconosciuto';
};

export default getAuthError;
